import { AbsoluteModelPath } from "../ModelPath";
import { EachCurrentCollision } from "../EachCurrentCollision";

import { Map2 } from "./Map2";

export class AbsoluteModelPathMap<V> extends Map2<AbsoluteModelPath, V> {
    private readonly eachCurrentCollision: EachCurrentCollision;

    public constructor(eachCurrentCollision: EachCurrentCollision = EachCurrentCollision.AreSame) {
        super();
        this.eachCurrentCollision = eachCurrentCollision;
    }

    protected areKeyEqual(left: AbsoluteModelPath, right: AbsoluteModelPath): boolean {
        return left.isEquals(right, this.eachCurrentCollision);
    }

    protected getKeyHash(key: AbsoluteModelPath): number {
        return key.getHash(this.eachCurrentCollision);
    }
}
